import { Box } from "@mui/material";
import { BrandEnum } from "../../../_common/enum/brand.enum";
import { getBrandLogoSymbol } from "../../../_helpers/brand.helper";
import { authScreenStyles } from "../../../_styles/authScreen.styles";
// import Logo from '../../../_assets/images/HC_Logo.png';


export function AuthLogo(params: { brand: BrandEnum } ) {

    return (
        <Box component="img" src={getBrandLogoSymbol(params.brand)} alt="Company Logo" sx={{ ...authScreenStyles.logo, width: '100%', height: 'auto', objectFit: 'contain' }} />
    );
}